module.exports = __webpack_public_path__ + "static/media/food-detail-01.1bd8d637.png";